import { useApiPrivateRequest } from "../../../shared/hooks/useApi";
import { LlmInfoShort } from "../models/LlmInfoShort";

export const useGetLlmInfo = () => {
  const {
    data: llmInfoList,
    call,
    isLoading,
    isFailed,
  } = useApiPrivateRequest<LlmInfoShort[]>((response) =>
    response.map((item: any) => new LlmInfoShort(item)),
  );

  const getLlmInfo = async () => {
    await call("/admin/llm", "GET");
  };

  return {
    llmInfoList,
    getLlmInfo,
    isLoading,
    isFailed,
  };
};
